import BrandTypes from 'constants/brand';
import { FeatureToggles } from 'types/FeatureToggleTypes';

export const PLANS_ALWAYS_ON_EXPERIMENT_ID = 'se-221';

export const shouldShowPlansAlwaysOn = (
  site: string,
  experiments?: Record<string, unknown>,
  featureToggles?: FeatureToggles,
): boolean => {
  if (site !== BrandTypes.VERY) return false;

  return !!(experiments?.[PLANS_ALWAYS_ON_EXPERIMENT_ID] || featureToggles?.enablePlansAlwaysOn);
};
